import { useDossierId } from "@/features/dossier-details";
import { AnimatePresence } from "motion/react";
import { cloneElement } from "react";
import { useOutlet } from "react-router";

// custom react router outlet to make it work with animatepresence (https://medium.com/@antonio.falcescu/animating-react-pages-with-react-router-dom-outlet-and-framer-motion-animatepresence-bd5438b3433b)
export const AnimatedOutlet = () => {
    const id = useDossierId();
    const element = useOutlet();

    return <AnimatePresence mode="wait">{element && cloneElement(element, { key: id })}</AnimatePresence>;
};
